<template>
  <div class="product-filter">
    <v-product-filter-pc
      v-if="inner_width >= 768"
      :product_filter="product_filter"
      :fake_payload="fake_payload"
      :payload="payload"
      :theme="theme"
    ></v-product-filter-pc>
    <v-product-filter-mb
      v-if="inner_width <= 768 && !hidden_mb"
      :product_filter="product_filter"
      :fake_payload="fake_payload"
      :payload="payload"
      :theme="theme"
      :filter_button="filter_button"
    ></v-product-filter-mb>
  </div>
</template>
<script>
import vProductFilterMb from "./productFilterMb";
import vProductFilterPc from "./productFilterPc";
export default {
  props: ["product_filter","theme", "api_get_product","filter_button" ,"hidden_mb"],
  data() {
    return {
      payload: {},
      fake_payload: {},
      init_price: [],
      inner_width: 0,
      price_method: null,
    };
  },
  beforeMount() {
    this.get_inner_width();
    let { items } = this.product_filter;
    // 从url获取筛选参数
    let search_obj = this.formatSearch();
    if (items && items.length) {
      items.forEach((item) => {
        let { type, id } = item;
        let payload = [];
        let split_symbol =
          type == "price" && item.method == "slider" ? ":" : ",";
        // url中如果有参数，则要赋值给显示
        if (Object.hasOwnProperty.call(search_obj, [type + "_" + id])) {
          payload = decodeURIComponent(search_obj[type + "_" + id]).split(
            split_symbol
          );
          if (split_symbol == ":") {
            let { rates, pricetype } = this.$store.state;
            payload = payload.map((item) => {
              return (item * rates[pricetype]) | 0;
            });
          }
        }
        this.payload[type + "_" + id] = payload;
        switch (type) {
          case "price":
            let { min, max } = item.price_value;
            //存储一下初始价格最大值和最小值
            let { rates, pricetype } = this.$store.state;
            this.init_price = [
              (min * rates[pricetype]) | 0,
              (max * rates[pricetype]) | 0,
            ];
            this.price_method = item.method;
            if (!isNaN(min) && !isNaN(max) && !payload.length) {
              this.payload[type + "_" + id] = this.init_price;
            }
            break;
          case "size":
          case "color":
            this.fake_payload[type + "_" + id] = item.attribute;
            break;
          case "tag":
            this.fake_payload[type + "_" + id] = item.taxonomy;
            break;
          default:
            break;
        }
      });
    }
    this.bus.$on("changeFilter", (payload) => {
      if (!payload.right_now) delete this.payload.right_now;
      this.payload = {
        ...this.payload,
        ...payload,
      };
    });
  },
  methods: {
    get_inner_width() {
      this.inner_width = window.innerWidth;
    },
    open_url(newV) {
      //search转换成对象格式
      if (this.inner_width >= 768 || newV.right_now === true) {
        let search_obj = this.formatSearch();
        for (const key in newV) {
          //价格为滑块显示时传来值为[最小值,最大值],需要处理成同价格列表时候的格式[0:10,10:20]
          let split_symbol =
            key.includes("price") && this.price_method == "slider" ? ":" : ",";
          let new_map = [];
          if (newV[key] && newV[key].length) {
            new_map = newV[key];
            if (split_symbol == ":") {
              let { rates, pricetype } = this.$store.state;
              new_map = newV[key].map((item) => {
                return (item / rates[pricetype]) | 0;
              });
            }
            search_obj[key] = new_map.join(split_symbol);
          } else {
            delete search_obj[key];
          }
        }
        //每次过滤条件需要把page调整回1;
        search_obj.page = 1;
        if (this.api_get_product) {
          this.api_get_product(search_obj);
        } else {
          //将对象转换成search格式
          let search = this.setObjSeach(search_obj);
          window.open(window.location.pathname + search, "_self");
        }
      }
    },
  },
  mounted() {
    this.$(window).resize(this.get_inner_width);
  },
  watch: {
    payload: {
      handler(newV) {
        this.open_url(newV);
        // this.debounce(this.open_url, 1000)(newV);
      },
      deep: true,
      // immediate: true,
    },
  },
  components: {
    vProductFilterMb,
    vProductFilterPc,
  },
};
</script>
<style  lang='scss'>
.product-filter {
  a {
    outline: none;
    -moz-outline: none;
  }
}
</style>